import { Component, EventEmitter, Injector, Output, Input, signal } from "@angular/core";
import { FormBuilder, Validators, FormGroup, ReactiveFormsModule } from "@angular/forms";
import { FormControlsOf, LockerComponentBase } from "../locker-equipment-base";
import { CBox_AdminEquipmentListItem, CBox_DvrEquipmentData } from "@server/services/cbox/public/api/v1/resources/internal/equipment/types";
import { InputTextModule } from "primeng/inputtext";
import { ApiService, handlePublicApiError } from "src/services/api/api.service";
import { CBox_PublicSuccessResponse } from "@server/services/cbox/public/api/v1/resources/common/request_base/types";
import { HttpErrorResponse } from "@angular/common/http";
import { ToastService } from "src/services/toast/toast.service";
import { DropdownModule } from "primeng/dropdown";

@Component({
  selector: "app-cbox-admin-card-terminal-template",
  templateUrl: "./cbox-admin-card-terminal-template.component.html",
  styleUrls: ["./cbox-admin-card-terminal-template.component.scss"],
  standalone: true,
  imports: [
    ReactiveFormsModule,
    InputTextModule,
    DropdownModule
  ]
})
export class CBoxAdminCardTerminalTemplateComponent extends LockerComponentBase<any> {
  @Input() equipmentToCopy?: CBox_AdminEquipmentListItem;
  @Input() loading!: boolean;
  @Output() onValueChanged = new EventEmitter<FormGroup<FormControlsOf<CBox_DvrEquipmentData>>>();

  providers = signal([]);
  loadingProviders = signal(true);

  constructor(
    private fb: FormBuilder,
    protected inj: Injector,
    private api: ApiService,
    private toastService: ToastService
  ) {
    super(inj);
    this.equipmentForm = this.fb.group({
      cardTerminal: this.fb.group({
        // `providerId`, not `provider`: the create action reads
        // `data.cardTerminal.providerId`
        // (`cbox_public_action_create_equipment.ts`) and
        // `CBox_CardTerminalEquipmentData` declares the same name. Sending
        // `provider` left the server connecting `paymentProvider` to
        // `id: undefined`, so every CARD_TERMINAL creation failed.
        providerId: ["", Validators.required],
        terminalIdentifier: ["", Validators.required],
        merchantIdentifier: ["", Validators.required]
      })
    }) as unknown as FormGroup<FormControlsOf<any>>;
  }

  get terminalForm(): FormGroup {
    return this.equipmentForm.get("cardTerminal") as FormGroup;
  }

  async init(): Promise<void> {
    this.fetchProviders();
  }

  protected patchCopiedEquipmentData(copiedEquipmentData: any): void {
    this.equipmentForm.patchValue({
      cardTerminal: {
        bankId: copiedEquipmentData.cardTerminal.bankId,
        providerId: copiedEquipmentData.cardTerminal.providerId,
        terminalIdentifier: copiedEquipmentData.cardTerminal.terminalIdentifier,
        merchantIdentifier: copiedEquipmentData.cardTerminal.merchantIdentifier
      }
    });
  }

  private fetchProviders(): void {
    this.api.get<CBox_PublicSuccessResponse<any>>("backend/internal/equipments/providers").subscribe((response) => {
      this.providers.set(response.data);
      this.loadingProviders.set(false);
    }, (e: HttpErrorResponse) => {
      handlePublicApiError(e, this.toastService);
      this.loadingProviders.set(false);
    });
  }
}